import React, { useCallback } from 'react';
import styled from 'styled-components';
import { Divider } from 'components/common/styled/common-styled';
import useSupportedLanguage from 'utils/data/language/useSupportedLanguage';
import useFeaturedListingsV3 from 'api/listing/useFeaturedListingsV3/useFeaturedListingsV3';
import { FeaturedExperienceItem } from '../../organisms/FeaturedExperienceItem';

const FeaturedExperiences = () => {
  const languageCode = useSupportedLanguage();

  const { data: featuredListings } = useFeaturedListingsV3({
    language: languageCode,
  });

  const renderItems = useCallback(
    () =>
      featuredListings?.map((listing, index) => (
        <FeaturedExperienceItem
          key={`featured-experience-item-${listing.id}`}
          listing={listing}
          isEven={index % 2 === 0}
        />
      )),
    [featuredListings],
  );

  if (featuredListings?.length === 0) {
    return null;
  }

  return (
    <Section className="featured-experiences">
      {renderItems()}
      <Divider className="featured-experiences__separator" space={48} />
    </Section>
  );
};

export default FeaturedExperiences;

/* The Divider is always the last child, so `nth-last-child(2)` targets the last featured item
   just above it. Mobile: collapse the item's bottom margin to 0 so the item butts right up to
   the Divider (which has its own 24px top space via `space={24}`). Desktop: normalise to 24px so
   the visual gap above the Divider matches the gap below it, keeping the separator centred in
   its own breathing room. */
const Section = styled.section`
  & > *:nth-last-child(2) {
    margin-bottom: 0;

    @media (min-width: 768px) {
      margin-bottom: 24px;
    }
  }
`;
